export const vendor = {
	definitions: "Definiciones",
	serviceFee: "Tasa de servicio",
	serviceTransfer: "Transferencia de servicio",
	serviceFeeVendor: "Vendor de la tasa de servicio",
	serviceFeeVendorRequired: "Seleccione el vendor de la tasa de servicio",
	serviceFeeVendorPlaceholder: "Seleccione el vendor que recibirá la transferencia",
	paymentMethodSuccess: "¡Los Métodos de pagos de Vendor fueron actualizados con éxito!",
	serviceTransferSuccess: "¡Vendor de la tasa de servicio fue actualizado con éxito!",
	saveMethods: "Guardar retenciones",
	resetChanges: "Restaurar valores iniciales",
	vendor: "Vendor",
	selectVendor: "Seleccione un vendor",
	paymentMethods: "Retención de todos los valores transaccionados en el lugar",
	tooltip:
		"Si algún vendor es seleccionado, todo el valor transaccionado en el método de pago elegido será retenido en el extracto de ese vendor.",
	paymentMethod: "Método de pago",
	paymentMethodOptions: {
		credit: "Crédito no integrado",
		debit: "Débito no integrado",
		cash: "Efectivo",
		voucher: "Voucher",
	},
	reprocessButton: "Reprocesar vendors",
	confirmReprocess: "Confirmar reprocesamiento",
	reprocessLabel: "Evento",
	reprocessPlaceholder: "Ingrese el ID del evento",
	reprocessEmptySelect: "Seleccione al menos un evento para reprocesar",
	reprocessSuccess: "Vendors reprocesados con éxito",
};
